import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { DfUiCarouselModule } from '@df/ui-carousel/carousel.module';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { CMS_COMPONENT_CAROUSEL_CONFIG } from './cms-component-carousel.config';
import { NCmsComponentCarousel } from './cms-component-carousel.interface';

let uid = 0;

export const cmsCarouselUid = () => {
    return uid++;
};

@Component({
    selector: 'cms-component-carousel',
    templateUrl: './cms-component-carousel.component.html',
    standalone: true,
    imports: [CommonModule, DfImageDirective, DfUiCarouselModule, ICmsClientModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<CmsComponentCarouselComponent>(CMS_COMPONENT_CAROUSEL_CONFIG)
export class CmsComponentCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: NCmsComponentCarousel.IData;

    readonly uid = `cms-carousel-${cmsCarouselUid()}`;
}
